/** @jsxImportSource @emotion/react */
import { useEffect } from "react";

import { css } from "@emotion/react";

import { useDetailsStore } from "@/stores/useDetailsStore";
import { useRedirectStore } from "@/stores/useRedirectStore";

interface DetailsContainerProps {
  contentHeight: string;
  children?: React.ReactNode;
  toMd?: boolean;
}

const DetailsContainer = ({
  contentHeight,
  children,
  toMd
}: DetailsContainerProps) => {
  const { isLoading } = useDetailsStore();

  const isTakeToCompaniesCardsTriggered = useRedirectStore(
    state => state.takeToCompaniesCards
  );

  // This effect scrolls to the element with the ID of company card, which is selected in dashboard CCExpiry widget
  useEffect(() => {
    const el =
      isTakeToCompaniesCardsTriggered &&
      document.getElementById(isTakeToCompaniesCardsTriggered);

    if (el && !isLoading) {
      setTimeout(() => {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 500); // Delay to ensure the element is rendered before scrolling
    }
  }, [isTakeToCompaniesCardsTriggered, isLoading]);

  return (
    <div
      id="details-container"
      css={css({
        height: contentHeight,
        overflowY: "scroll",
        padding: toMd ? "0 16px 0 0" : "unset"
      })}
    >
      {children}
    </div>
  );
};

export default DetailsContainer;
